
const LIST_TYPES = ['numbered-list', 'bulleted-list']
const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']
const HEADING_TYPES = ['heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5', 'heading-6']

export {
    LIST_TYPES,
    TEXT_ALIGN_TYPES,
    HEADING_TYPES
}